module.exports = __webpack_public_path__ + "static/media/crypto.4c846db1.png";